module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.eee098469f665d930985.js");
};